import "./onenewsnewpage.scss";
import backArrow from "images/backArrow.svg";
import { useEffect } from "react";
import LoadedComponent from "./LoadedComponent/index";
import { baseUrl } from "stores/main";

import { inject, observer } from "mobx-react";
import { NavLink, useParams } from "react-router-dom";
import moment from "moment";
import parse from "html-react-parser";

const OneNewsNewPage = ({ getOneNews, selectedNews, isLoading }) => {
  let { id } = useParams();

  useEffect(() => {
    getOneNews(id);
  }, []);

  return (
    <div className="news-page">
      <div className="news-page__topcols">
        <NavLink to="/allnews" className="d-flex gap-3">
          <img alt="" src={backArrow} />
          <p className="news-page__topcols-text">Вернуться ко всем новостям</p>
        </NavLink>
      </div>
      <LoadedComponent isLoading={isLoading}>
        <>
          {selectedNews && (
            <div className="news-page__rows">
              <p className="news-page__rows-date">
                {moment(selectedNews["time_create"]).format("L")}
              </p>
              {selectedNews["preview_url"] !== -1 ? (
                <img
                  src={`${baseUrl}${selectedNews["preview_url"]}`}
                  className="news-page__rows-date-img"
                  alt=""
                />
              ) : (
                ""
              )}
              <p className="news-page__rows-title">{selectedNews["title"]}</p>
              <div className="news-page__rows-text">
                {parse(selectedNews["content"].replace(/style="[^"]+"/g))}
              </div>
            </div>
          )}
        </>
      </LoadedComponent>
    </div>
  );
};

export default inject(({ newsStore }) => {
  const { getOneNews, selectedNews, isLoading } = newsStore;
  return { getOneNews, selectedNews, isLoading };
})(observer(OneNewsNewPage));
